<template>
    <div class="panel--bg">
        <div class="panel__header"></div>
        <div class="panel__body">
            <div class="panel__profile_img">
                <div class="panel__profile_img__img">
                    <img :src="getPlaceholder" ref="profilePicture" />
                </div>
            </div>
            <div class="panel__intro">
                <h2>{{profile.name}}</h2>
                <button v-if="profilePanelVisible" @click="toggleProfilePanel" class="button--alt green bold">
                    <i class="icons icon-arrow-up"></i>
                    <span> {{$t('dashboard.profile.hide_full_profile')}}</span>
                </button>
                <button v-else @click="toggleProfilePanel" class="button--alt green bold">
                    <i class="icons icon-arrow-down"></i>
                    <span>{{$t('dashboard.profile.view_full_profile')}}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    @Component
    export default class ProfileIntroPanel extends Vue {
        name = 'profile-intro-panel';

        profilePanelVisible = false;

        created() {
            this.getProfilePicture();
        }

        get profile() {
            return this.$store.state.profile.profile;
        }

        toggleProfilePanel() {
            this.profilePanelVisible = !this.profilePanelVisible;
            this.$emit('profilePanelChange', this.profilePanelVisible);
        }

        getProfilePicture() {
            if (this.profile.has_profile_picture) {
                this.axios.get(`/account/${this.profile.id}/profilepicture`, { responseType:'blob' }).then(
                    res => {
                        if (res.data.type !== 'image/jpeg') return;
                        let urlCreator = window.URL || window.webkitURL;
                        let url = urlCreator.createObjectURL(res.data);
                        this.$refs.profilePicture.attributes.src.value = url;
                    }
                ).catch(err => err);
            }
        }

        get getPlaceholder() {
            return `/static/img/placeholder-${this.profile.gender === 'f' ? 'fe' : ''}male.png`;
        }

    }

    Vue.component('profile-intro-panel', ProfileIntroPanel);
</script>



// WEBPACK FOOTER //
// src/components/panels/profile/ProfileIntroPanel.vue